__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.51.10-6706-amber-user-website-prod-hk-1810/assets/";